import * as Yup from "yup";

import { phoneRegex } from "../../../../constants/regex";
import { JobFrequencyEnum } from "../../Contracts/CreateJobAndSchedule/CreateJobAndSchedule.model";
import {
  CustomerCategoryEnum,
  RecurrenceEnum,
  TLeadFormData,
} from "../Lead.model";

export const leadFormSchema = Yup.object().shape({
  contractTypeId: Yup.number().required("Field is required"),
  customerCategory: Yup.mixed<CustomerCategoryEnum>()
    .oneOf(Object.values(CustomerCategoryEnum))
    .required("Field is required"),
  name: Yup.string()
    .when("customerCategory", {
      is: (val: CustomerCategoryEnum) => val === CustomerCategoryEnum.INDIVIDUAL,
      then: Yup.string().required("Field is required"),
    })
    .nullable(true),
  surname: Yup.string().nullable(true),
  companyName: Yup.string()
    .when("customerCategory", {
      is: (val: CustomerCategoryEnum) => val === CustomerCategoryEnum.CORPORATE,
      then: Yup.string().required("Field is required"),
    })
    .nullable(true),
  contactName: Yup.string()
    .when("customerCategory", {
      is: (val: CustomerCategoryEnum) => val === CustomerCategoryEnum.CORPORATE,
      then: Yup.string().required("Field is required"),
    })
    .nullable(true),
  billingContact: Yup.string().required("Field is required"),
  billingAddress: Yup.string().nullable(true),
  country: Yup.string().required("Field is required"),
  address: Yup.string().required("Field is required"),
  city: Yup.string().required("Field is required"),
  billingCity: Yup.string().required("Field is required"),
  ZIP: Yup.string()
    .matches(/^\d+(-\d+)*$/, "ZIP should only contain numbers and a hyphen (-)")
    .required("Field is required"),
  billingZIP: Yup.string().required("Field is required"),
  fax: Yup.string().nullable(true),
  title: Yup.string().nullable(true),
  state: Yup.string().required("Field is required"),
  billingState: Yup.string().required("Field is required"),
  mobile: Yup.string().matches(phoneRegex, "Invalid phone number").nullable(true),
  website: Yup.string()
    .test({
      name: "notEmptyOrInvalidUrl",
      test: (value) => {
        if (!value) {
          return true;
        }

        const urlPattern =
          /^(https?:\/\/)?(www\.)?[a-zA-Z0-9-]+\.[a-zA-Z]{2,}\/?[a-zA-Z0-9-._~:/?#[\]@!$&'()*+,;=]*$/;
        return urlPattern.test(value);
      },
      message: "Invalid URL",
    })
    .nullable(true),
  email: Yup.string().email("Wrong email").required("Field is required"),
  phone: Yup.string().matches(phoneRegex, "Invalid phone number").required("Field is required"),
  depositAmount: Yup.number()
    .transform((value) => (Number.isNaN(value) ? 0 : value))
    .default(0),
  recurEvery: Yup.number().nullable(true),
  daysOfWeek: Yup.array().of(Yup.number()).nullable(true),
  dayOfMonth: Yup.number().nullable(true),
  monthOfYear: Yup.number().nullable(true),
  estimatedStartDate: Yup.date(),
  laborGoalHours: Yup.number()
    .transform((value) => (Number.isNaN(value) ? null : value))
    .nullable(true)
    .required("Field is required"),
  laborGoalBudget: Yup.number().nullable(true).required("Field is required"),
  createdDate: Yup.date(),
});

export const buildLeadFormDefaultValues = (): Partial<TLeadFormData> => ({
  customerCategory: CustomerCategoryEnum.CORPORATE,
  name: "",
  companyName: "",
  depositAmount: 0,
  recurrence: RecurrenceEnum.N,
  dayOfMonth: 1,
  monthOfYear: 0,
  frequency: JobFrequencyEnum.WEEKLY,
  recurEvery: 1,
  daysOfWeek: [],
  country: "USA",
  street: "",
  billingStreet: "",
});
